<template>
  <MainLayout>
    <div id="contents">
      <PaymentComplete />
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout.vue';
import PaymentComplete from '@/components/PaymentComplete.vue';

export default {
  name: 'PaymentCompleteView',
  components: {
    MainLayout,
    PaymentComplete,
  },
};
</script>
